import React, { Component } from 'react';
import { func, object } from 'prop-types';
import {
  ascend,
  contains,
  descend,
  map,
  prepend,
  prop,
  sortWith,
  toLower,
  type,
  without,
} from 'ramda';
import moment from 'moment';
import DatePicker from 'material-ui/DatePicker';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

// Redux
import { connect } from 'react-redux';
import { getAuditActions, getAuditLog } from "../../../../actions/auditLog/auditLogActions";
import * as AuditLogTypes from '../../../../actions/auditLog/types';

import AuditLogTable from './AuditLogTable';
import FileDownload from '../../../FileDownload';
import LoadingState from '../../../LoadingState';

import s from './AuditLog.css';


export class AuditLog extends Component {
  static propTypes = {
    auditLog: object,
    getAuditActions: func,
    getAuditLog: func,
    loadingState: object,
  };

  constructor(props) {
    super(props);

    this.state = {
      startDate: moment().subtract(7,'d').toDate(),
      endDate: moment().toDate(),
      action: null,
      data: null,
      sortValue: null,
      sortDescending: true,
      downloadPath: null,
    };

    const sortableValues = ['date', 'modifiedBy', 'action', 'field'];

    const orderedsortableValues = (prop, sortableValues) =>
      prepend(prop, without(prop, sortableValues));

    this.sortData = (sortValue, sortDescending, data) =>
      sortDescending ?
        sortWith(map(x => descend(prop(x)), orderedsortableValues(sortValue, sortableValues)), data) :
        sortWith(map(x => ascend(prop(x)), orderedsortableValues(sortValue, sortableValues)), data);

    this.lower = str => {
      if (type(str) === 'String') {
        return toLower(str);
      }
      return str;
    };
  };

  componentDidMount() {

    this.props.getAuditActions();

    this.handleGetAuditLog();

    // add aria-label to Action SelectField's arrow button
    let rootActionDropdownContainer = document.getElementById("action");
    let child = rootActionDropdownContainer.children[0];
    let arrowButton = child.children[2];
    arrowButton.setAttribute("aria-label", "Actions dropdown arrow")

  }

  handleGetAuditLog = () => {
    const requestObj = {
      startDate: moment(this.state.startDate).format('x'),
      endDate: moment(this.state.endDate).add(1, 's').format('x'),
      action: this.state.action,
    };

    const successCallback = () =>
      this.setState({
        sortValue: 'date',
        data: this.sortData('date', this.state.sortDescending, map(x => map(y => this.lower(y), x), this.props.auditLog.searchResults)),
      });

    this.props.getAuditLog(requestObj, successCallback);

  };

  handleSubmit = e => {

    e.preventDefault();

    this.handleGetAuditLog();

  };

  isLoadingAuditLog = (loadingState) => contains(AuditLogTypes.GET_AUDIT_LOG, loadingState.requests);

  onDatePickerDialogShow = (dateType) =>{
    let dialogDivs = document.querySelectorAll("div[data-reactroot]");

    switch(dateType) {
      case "START":
        setTimeout(()=>{
          // the dialog container for the start date happens to be in this index...
          // when that dialog is visible...the style attribute is
          // position: fixed; box-sizing: border-box; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); z-index: 1500; top: 0px; left: 0px; width: 100%; height: 100%; transition: left 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms; padding: 219.5px 0px 0px; min-height: 434px; min-width: 310px;
          // querying by that does not work for some reason
          let DateDialogContainer = dialogDivs[2];
          //let DateDialogContainer = document.querySelector('div[style="position: fixed; box-sizing: border-box; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); z-index: 1500; top: 0px; left: 0px; width: 100%; height: 100%; transition: left 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms; padding: 219.5px 0px 0px; min-height: 434px; min-width: 310px;"]')
          let buttonsContainer = DateDialogContainer.querySelector('div[style="display: flex; justify-content: space-between; background-color: inherit; height: 48px;"]');
          let previousMonthButton = buttonsContainer.children[0];
          let nextMonthButton = buttonsContainer.children[2];

          previousMonthButton.setAttribute("aria-label", "Previous month button");
          nextMonthButton.setAttribute("aria-label", "Next month button");

        }, "150")
        break;
      case "END":
        setTimeout(()=>{
          // the div that holds the dialog for End Date
          // when that dialog is visible, the style attribute is
          // position: fixed; box-sizing: border-box; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); z-index: 1500; top: 0px; left: 0px; width: 100%; height: 100%; transition: left 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms; padding: 219.5px 0px 0px; min-height: 434px; min-width: 310px;
          // querying by that does not work for some reason
          //let DateDialogContainer = document.querySelector('div[style="position: fixed; box-sizing: border-box; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); z-index: 1500; top: 0px; left: 0px; width: 100%; height: 100%; transition: left 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms; padding: 219.5px 0px 0px; min-height: 434px; min-width: 310px;"]')
          let DateDialogContainer = dialogDivs[3];
          // this div holds the previous month button, the month/year label, and next month button
          let buttonsContainer = DateDialogContainer.querySelector('div[style="display: flex; justify-content: space-between; background-color: inherit; height: 48px;"]');
          let previousMonthButton = buttonsContainer.children[0];
          let nextMonthButton = buttonsContainer.children[2];

          previousMonthButton.setAttribute("aria-label", "Previous month button");
          nextMonthButton.setAttribute("aria-label", "Next month button");

        }, "150")
        break;
      default:
        break;
    }
  }

  /*
  * material ui related error in rendering the <SelectField />. Material ui's internal test runner fails our tests because it expects a single
  * React component on render, not an array.
  * @todo Failed prop type: Invalid prop `children` of type `array` supplied to `MuiThemeProvider`, expected a single ReactElement.
  * */
  render = () => {
    const isLoadingAuditLog = this.isLoadingAuditLog(this.props.loadingState);
    
    return (
      <section className={s.component}>
        <h3 className={s.header}>
          Activity Log
        </h3>
        <div className={s.container}>
          <form id="auditLogForm" onSubmit={this.handleSubmit} className={s.form}>
            <span className={s.searchSelector}>
              <DatePicker
                  id="startDate"
                  className={s.datePicker}
                  floatingLabelText="Start date"
                  value={this.state.startDate}
                  textFieldStyle={{width: '100%'}}
                  onChange={(event, date) => {this.setState({startDate: date})}}
                  onShow={this.onDatePickerDialogShow.bind(null, "START")}
              />
              <DatePicker
                  id="endDate"
                  className={s.datePicker}
                  floatingLabelText="End date"
                  defaultDate={this.state.endDate}
                  textFieldStyle={{width: '100%'}}
                  onChange={(event, date) => this.setState({endDate: date})}
                  onShow={this.onDatePickerDialogShow.bind(null,"END")}
              />
            <SelectField
              id="action"
              title="expand"
              className={s.dropdown}
              floatingLabelStyle={{color: '#222222', fontWeight:'normal'}}
              floatingLabelText="Action"
              floatingLabelFixed={true}
              value={this.state.action}
              iconStyle={{fill:'#222222'}}
              onChange={(event, index, action) => this.setState({action})}
            >
              <MenuItem value={null} primaryText="All"/>
              {this.props.auditLog.actions &&
                map(item =>
                  <MenuItem id={`auditLog__${item}`} key={item} value={item} primaryText={item} />,
                  this.props.auditLog.actions)
              }
            </SelectField>
            </span>
            <span className={s.auditLogButtons}>
              <button
                id="submitAuditLogSearch"
                type='submit'
                className={s.btn}
                disabled={isLoadingAuditLog}
              >
                {isLoadingAuditLog ? (
                  <LoadingState context="auditlog"/>
                ) : (
                  'Submit'
                )}
              </button>
              <button
                id="downloadCsv"
                onClick={() => this.setState({downloadPath: `../api/audit/download`})}
                className={s.btn}
                disabled={isLoadingAuditLog}
              >
                Download csv
              </button>
            </span>
          </form>
        {this.state.downloadPath &&
          <FileDownload
            actionPath={this.state.downloadPath}
            queryParams={{
              startDate: moment(this.state.startDate).format('x'),
              endDate: moment(this.state.endDate).add(1, 's').format('x'),
              action: this.state.action,
            }}
            onDownloadComplete={() => { this.setState({ downloadPath: null }) }}
          />
        }
        {this.state.data &&
          <AuditLogTable
            data={this.state.data}
            update={(data, sortValue, sortDescending) => { this.setState({ data, sortValue, sortDescending }) }}
            sortData={this.sortData}
            sortValue={this.state.sortValue}
            sortDescending={this.state.sortDescending}
          />
        }
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  loadingState: state.loadingState,
  auditLog: state.auditLog,
});

const mapDispatchToProps = dispatch => ({
  getAuditActions: () => dispatch(getAuditActions()),
  getAuditLog: (data, successCb, errorCb) => dispatch(getAuditLog(data, successCb, errorCb)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AuditLog);


// WEBPACK FOOTER //
// ./src/components/Pages/Account/AuditLog/AuditLog.js